import React, { useState } from 'react';
import { BookingStatus } from '@round/api';
import BookingStatusBadge from '../../BookingStatusBadge/BookingStatusBadge';
import { Popover } from '@round/ui-kit';
import Card from '../../../../ui/Card/Card';
import styles from './StatusPicker.module.css';
import { ReactComponent as ChevronIcon } from '../../../../assets/Chevron.svg';
import { StatusMap } from '../../../../utils/constants';
import cn from 'classnames';

type StatusPickerProps = {
    status: BookingStatus;
    onChange?: (value: BookingStatus) => void;
    readonly?: boolean;
};

const StatusPicker = ({ status, onChange, readonly }: StatusPickerProps) => {
    const [ref, setRef] = useState<HTMLDivElement | null>(null);
    const allowedStatuses = StatusMap[status] ?? [];

    return (
        <div ref={setRef} className={cn(styles.container, { [styles.readonly]: readonly })}>
            <BookingStatusBadge className={styles.value} status={status} />
            {!readonly && allowedStatuses.length ? <ChevronIcon className={styles.chevron} /> : null}
            <Popover
                disabled={readonly || allowedStatuses.length === 0}
                anchorElement={ref}
                showOn="click"
                options={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 5],
                            },
                        },
                    ],
                    placement: 'bottom-start',
                }}
            >
                <Card className={styles.dropdown}>
                    {allowedStatuses.map((statusOption) => (
                        <button
                            key={status}
                            className={styles.optionButton}
                            type="button"
                            onClick={() => {
                                if (typeof onChange === 'function') {
                                    onChange(statusOption);
                                }
                            }}
                        >
                            <BookingStatusBadge status={statusOption} />
                        </button>
                    ))}
                </Card>
            </Popover>
        </div>
    );
};

export default StatusPicker;
